<template>
  <div id="auth-layout">
     <header class="topbar color-head-grey " >
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header color-logo-grey" >
        <a class="navbar-brand" href="#">
           <img src="../assets/images/simantap-small.png" width="30"  alt="logo"  />
          <!-- Logo icon -->
         
          <!--End Logo icon -->
          <!-- Logo text -->
          <span 
            class="dark-logo"
            style=" font-weight: 500; padding-left: 10px;"
          >
          </span>
        </a>
      </div>
      <div class="navbar-collapse">
            <ul class="navbar-nav ">
                <li class="nav-item hidden-sm-down"> 
                      <a class="nav-link hidden-sm-down waves-effect waves-dark" href="#" style="text-transform: uppercase; font-size: 12px; font-weight: 600;">
                   SISTEM INFORMASI MANAJEMEN TALENTA - PEMERINTAH DAERAH KABUPATEN BOGOR
                            
                      </a>
                  </li>
            </ul>
             <ul class="navbar-nav ml-auto">
                <li class="nav-item hidden-sm-down"> 
                      <a class="nav-link hidden-sm-down waves-effect waves-dark" href="#" style="text-transform: uppercase; font-size: 12px;">
                       
                        
                         <img src="../assets/images/berakhlak.png" width="100" />
                      </a>
                  </li>

             </ul>

      </div>
    </nav>
  </header>

    <slot></slot>
  </div>
</template>

<script>
export default {
   name: "auth",
};
</script>



// WEBPACK FOOTER //
// src/layout/Auth.vue